import React, { useMemo } from "react";

function MapOne({ contacts = [], loading = false }) {
  const addressContacts = useMemo(() => {
    return contacts.filter(
      (contact) =>
        contact?.Adres ||
        contact?.phone ||
        contact?.email ||
        (contact?.latitude && contact?.longitude),
    );
  }, [contacts]);

  const companyTitle = useMemo(() => {
    const record = contacts.find((contact) => contact?.unvan);

    return (
      record?.unvan || "Demirsan Soğuk Çekme Sanayi ve Ticaret Anonim Şirketi"
    );
  }, [contacts]);

  const getIcon = (contact) => {
    const title = String(contact?.title || "").toLocaleLowerCase("tr-TR");
    const hasAddress = contact?.Adres || contact?.latitude;
    const hasPhone = contact?.phone;
    const hasEmail = contact?.email;

    if (title.includes("fabrika")) return "fas fa-industry";
    if (title.includes("ofis") || title.includes("merkez")) return "fas fa-building";
    if (title.includes("satış") || title.includes("satis") || title.includes("export") || title.includes("ihracat")) return "fas fa-tag";
    if (!hasAddress && !hasPhone && hasEmail) return "fas fa-envelope";

    return "fas fa-map-marker-alt";
  };

  const getPhoneHref = (phone = "") => {
    const cleanPhone = String(phone).replace(/[^\d+]/g, "");
    return `tel:${cleanPhone}`;
  };

const getMapUrl = (contact) => {
  const latitude = String(contact?.latitude || "").trim();
  const longitude = String(contact?.longitude || "").trim();

  const query = [
    contact?.unvan,
    contact?.Adres
  ]
    .filter(Boolean)
    .join(" ");

  // Koordinat + işletme bilgisi varsa:
  // q işletmeyi bulur, ll haritayı doğru koordinata götürür.
  if (latitude && longitude && query) {
    return `https://www.google.com/maps?q=${encodeURIComponent(
      query
    )}&ll=${encodeURIComponent(
      `${latitude},${longitude}`
    )}&z=16&output=embed`;
  }

  // Sadece koordinat varsa
  if (latitude && longitude) {
    return `https://www.google.com/maps?q=${encodeURIComponent(
      `${latitude},${longitude}`
    )}&z=16&output=embed`;
  }

  // Koordinat yoksa eski yöntem
  if (query) {
    return `https://www.google.com/maps?q=${encodeURIComponent(
      query
    )}&z=16&output=embed`;
  }

  return "";
};

  if (loading) {
    return null;
  }

  if (addressContacts.length === 0) {
    return null;
  }

  return (
    <div>
      <style>
        {`
          .demirsan-map-area {
            padding: 30px 0;
            background: #f7f7f7;
          }

          .demirsan-map-title-area {
            margin-bottom: 40px;
            text-align: center;
          }

          .demirsan-map-subtitle {
            margin: 0 0 10px;
            color: #df0a0a;
            font-size: 18px;
            font-weight: 600;
            line-height: 1.2;
            text-transform: uppercase;
          }

          .demirsan-map-main-title {
            max-width: 800px;
            margin: 0 auto;
            color: #1c2539;
            font-size: 36px;
            font-weight: 700;
            line-height: 1.3;
          }

          /* Üstteki iletişim kutuları */
          .demirsan-contact-card {
            display: flex;
            flex-direction: column;
            height: 100%;
            padding: 30px;
            background: #fff0f0;
            border: 1px solid #f3dddd;
            border-radius: 10px;
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.06);
          }

          .demirsan-contact-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 52px;
            height: 52px;
            margin-bottom: 20px;
            border-radius: 50%;
            background: #ffdada;
            color: #df0a0a;
            font-size: 21px;
          }

          .demirsan-contact-card-title {
            margin: 0 0 16px;
            color: #1c2539;
            font-size: 22px;
            font-weight: 700;
          }

          .demirsan-contact-card p {
            margin: 0 0 14px;
            color: #555555;
            font-size: 16px;
            line-height: 1.7;
            white-space: pre-line;
          }

          .demirsan-contact-card a {
            display: block;
            margin-top: 5px;
            color: #444444;
            font-size: 16px;
            line-height: 1.7;
            text-decoration: none;
            transition: color 0.2s ease;
            word-break: break-word;
          }

          .demirsan-contact-card a:hover {
            color: #df0a0a;
          }

          /* Haritalar */
          .demirsan-maps-row {
            margin-top: 40px;
          }

          .demirsan-map-card {
            height: 100%;
            overflow: hidden;
            background: #ffffff;
            border: 1px solid #e8e8e8;
            border-radius: 10px;
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.07);
          }

          .demirsan-map-card-title {
            margin: 0;
            padding: 18px 22px;
            border-bottom: 1px solid #eeeeee;
            color: #1c2539;
            font-size: 20px;
            font-weight: 700;
          }
.demirsan-map-card iframe {
  display: block;
  width: 100%;
  height: 520px;
  border: 0;
}
          @media (max-width: 991.98px) {
            .demirsan-map-area {
              padding: 55px 0;
            }

            .demirsan-contact-card {
              margin-bottom: 5px;
            }

            .demirsan-map-main-title {
              font-size: 31px;
            }
          }

          @media (max-width: 767.98px) {
            .demirsan-map-area {
              padding: 45px 0;
            }

            .demirsan-map-title-area {
              margin-bottom: 30px;
            }

            .demirsan-map-main-title {
              font-size: 27px;
            }

            .demirsan-contact-card {
              padding: 24px 20px;
            }

            .demirsan-maps-row {
              margin-top: 25px;
            }

          .demirsan-map-card iframe {
    height: 420px;
  }
          }
        `}
      </style>

      <section className="rts-map-area demirsan-map-area" id="address">
        <div className="container">
          <div className="demirsan-map-title-area">
            <p className="demirsan-map-subtitle">İLETİŞİM BİLGİLERİ</p>

            <h2 className="demirsan-map-main-title">{companyTitle}</h2>
          </div>

          {/* Üstteki dinamik kutular */}
          <div className="row g-4">
            {addressContacts.map((contact) => (
              <div
                className="col-lg-4 col-md-6 col-12"
                key={`contact-${contact.id}`}
              >
                <div className="demirsan-contact-card">
                  <div className="demirsan-contact-icon">
                    <i className={getIcon(contact)} />
                  </div>

                  <h3 className="demirsan-contact-card-title">
                    {contact.title || "İletişim"}
                  </h3>

                  {contact.Adres && <p>{contact.Adres}</p>}

                  {contact.phone &&
                    String(contact.phone)
                      .split(/[,;\n]+/)
                      .map((p) => p.trim())
                      .filter(Boolean)
                      .map((p) => (
                        <a href={getPhoneHref(p)} key={p}>
                          <i className="fas fa-phone-alt" /> {p}
                        </a>
                      ))}

                  {contact.email &&
                    String(contact.email)
                      .split(/[,;\n]+/)
                      .map((e) => e.trim())
                      .filter(Boolean)
                      .map((e) => (
                        <a href={`mailto:${e}`} key={e.toLowerCase()}>
                          <i className="fas fa-envelope" style={{ marginRight: 6 }} />
                          {e}
                        </a>
                      ))}
                </div>
              </div>
            ))}
          </div>

          {/* Alttaki dinamik haritalar */}
          <div className="row g-4 demirsan-maps-row">
            {addressContacts.map((contact) => {
              if (!contact?.Adres && !contact?.latitude) return null;

              const mapUrl = getMapUrl(contact);

              if (!mapUrl) return null;

              return (
                <div className="col-lg-6 col-md-12" key={`map-${contact.id}`}>
                  <div className="demirsan-map-card">
                    <h3 className="demirsan-map-card-title">
                      {contact.title || "Konum"}
                    </h3>

                    <iframe
                      title={contact.title || "Konum"}
                      src={mapUrl}
                      loading="lazy"
                      allowFullScreen
                      referrerPolicy="no-referrer-when-downgrade"
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}

export default MapOne;
